import { render } from "./CreateView.vue?vue&type=template&id=18ea6f12&scoped=true"
import script from "./CreateView.vue?vue&type=script&lang=js"
export * from "./CreateView.vue?vue&type=script&lang=js"

import "./CreateView.vue?vue&type=style&index=0&id=18ea6f12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ea6f12"]])

export default __exports__